//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../no/Builder.js";
import "../Annotations/Annotations.AssociatedObjectsBuilder.js";
import "../no/SelectNXObjectList.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.PlaneBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../Annotations/Annotations.TextWithEditControlsBuilder.js";
import "../no/Annotations.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AssociatedObjects",0,"Annotations.AssociatedObjectsBuilder",0],[0,"IncludeLeader",1,0],[1,"Joins",0,"SelectNXObjectList",0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"Plane",0,"Annotations.PlaneBuilder",0],[0,"Precision",1,0],[1,"Style",0,"Annotations.StyleBuilder",0],[1,"Text",0,"Annotations.TextWithEditControlsBuilder",0]],[],[]];
SPLM.Join.JoinNoteBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.JoinNoteBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.JoinNoteBuilder.AttrPrecision = Object.freeze({
    "Zero" : "Zero", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six"});

export default SPLM;